import React from 'react';
import { Section, TextAreaLabel, TranslateDropdown } from '@weezevent/nacre';
import { Icon } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import Style from './displayModuleMessages.module.css';
import PropTypes from 'prop-types';

export const DisplayTranslatedMessage = ({
    languageSelected,
    defaultLanguage,
    valueTextArea,
    setLanguageSelected,
    listLanguage,
    valuesArray,
    keyMessage,
    setFormModuleDisplay
}) => {
    const { t } = useTranslation();

    const checkLanguageTranslateComplete = React.useCallback(() => {
        let ret = [];

        listLanguage.forEach(language => {
            if (valuesArray[language.value][keyMessage]?.length) {
                ret.push(language.value);
            }
        });
        return ret;
    }, [listLanguage, valuesArray, keyMessage]);

    const changeText = React.useCallback(
        value => {
            let ret = [];
            listLanguage.forEach(language => {
                if (!value && language.value === languageSelected) {
                    ret.push('');
                } else if (language.value === languageSelected) {
                    ret.push(`[${languageSelected}]${value}`);
                } else if (valuesArray[language.value][keyMessage]) {
                    ret.push(`[${language.value}]${valuesArray[language.value][keyMessage]}`);
                }
            });
            setFormModuleDisplay(keyMessage, ret.filter(t => t).join('|'));
        },
        [setFormModuleDisplay, listLanguage, languageSelected, keyMessage]
    );

    const reloadOrigin = React.useCallback(() => {
        let defaultText = listLanguage.find(obj => obj.value === languageSelected);
        changeText(defaultText.default[keyMessage]);
    }, [changeText, languageSelected, listLanguage, keyMessage]);

    return (
        <Section>
            <TextAreaLabel
                key={keyMessage}
                onChange={change => {
                    changeText(change.target.value);
                }}
                rows={2}
                errors={[]}
                field={{}}
                required={false}
                value={valueTextArea}
                style={{ resize: 'none' }}
            >
                <div className={Style['form-display--title']}>
                    <span>{t('attendees.invitations.message.labels.body')}</span>
                    <div className={Style['form-display--pipe-translate']}>
                        <TranslateDropdown defaultValue={defaultLanguage} languages={listLanguage} selected={checkLanguageTranslateComplete()} onChange={setLanguageSelected} />
                    </div>
                </div>
            </TextAreaLabel>
            <div
                className="reload-text"
                onClick={() => {
                    reloadOrigin();
                }}
            >
                <Icon name="redo" /> {t('ticket.ticket_option.module.message_information.apply-originat-text')}
            </div>
        </Section>
    );
};

DisplayTranslatedMessage.propTypes = {
    languageSelected: PropTypes.string.isRequired,
    defaultLanguage: PropTypes.string.isRequired,
    valueTextArea: PropTypes.string,
    setLanguageSelected: PropTypes.func.isRequired,
    listLanguage: PropTypes.array.isRequired,
    valuesArray: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    keyMessage: PropTypes.string.isRequired,
    setFormModuleDisplay: PropTypes.func.isRequired
};

export default DisplayTranslatedMessage;
